import {
  ANTISENSE_MODIFICATION,
  ANTISENSE_OVERHANG,
  DUPLEX, OLIGO_NAME,
  PURITY,
  RESEARCHER_NAME,
  OVERHANG,
  RNA_TYPE,
  SCALE,
  SENSE_MODIFICATION,
  SENSE_SEQUENCE,
  RNA_OPTIONS,
  VALID_OVERHANG_OPTIONS,
  VALID_SENSE_OPTIONS
} from 'src/components/OligosForm/constants';
import { config } from 'src/constants';
import { cartRequestMockHeaders } from 'src/mocks';

import OligoFormState from './OligoFormState';

const url = '/v2/oligos/rna-tubes/submit';

export default class OligoForm extends OligoFormState {
    static NAME = 'oligo_form';

    static STEALTH = 'stealth';

    static getCreateConfig() {
      return {
        url,
        ...(config.isDevEnv ? { headers: cartRequestMockHeaders } : {})
      };
    }

    static processApiData = (collectedData) => {
      const processedData = {};
      const researcherName = collectedData[RESEARCHER_NAME]?.value;
      const oligoName = collectedData[OLIGO_NAME]?.value;
      const rnaType = collectedData[RNA_TYPE]?.value;
      const senseSequence = collectedData[SENSE_SEQUENCE]?.value;
      const rnaSense5Modification = collectedData[SENSE_MODIFICATION]?.value;
      const duplex = collectedData[DUPLEX]?.value;
      const rnaSenseOverhang = collectedData[OVERHANG]?.value;
      const rnaSynthesisScale = collectedData[SCALE]?.value;
      const rnaPurification = collectedData[PURITY]?.value;
      const rnaAntisense5Modification = collectedData[ANTISENSE_MODIFICATION]?.value;
      const rnaAntisenseOverhang = collectedData[ANTISENSE_OVERHANG]?.value;

      if (researcherName) {
        processedData.researcherName = researcherName;
      }

      if (oligoName) {
        processedData.oligoName = oligoName;
      }

      if (rnaType) {
        processedData.rnaType = rnaType;
      }

      if (senseSequence) {
        processedData.senseSequence = senseSequence;
      }

      if (rnaSense5Modification &&
          VALID_SENSE_OPTIONS.includes(rnaSense5Modification) &&
          rnaType === RNA_OPTIONS.SI_RNA) {
        processedData.rnaSense5Modification = rnaSense5Modification;
      }

      if (rnaSenseOverhang &&
          VALID_OVERHANG_OPTIONS.includes(rnaSenseOverhang) &&
          rnaType === RNA_OPTIONS.SI_RNA) {
        processedData.rnaSenseOverhang = rnaSenseOverhang;
      }

      if (rnaSynthesisScale) {
        processedData.rnaSynthesisScale = rnaSynthesisScale;
      }

      if (rnaPurification) {
        processedData.rnaPurification = rnaPurification;
      }

      if (duplex && rnaType === RNA_OPTIONS.SI_RNA) {
        processedData.duplex = duplex;
      }

      if (duplex &&
          rnaType === RNA_OPTIONS.SI_RNA &&
          rnaAntisense5Modification &&
          VALID_SENSE_OPTIONS.includes(rnaAntisense5Modification)) {
        processedData.rnaAntisense5Modification = rnaAntisense5Modification;
      }

      if (duplex &&
          rnaType === RNA_OPTIONS.SI_RNA &&
          rnaAntisenseOverhang &&
          VALID_OVERHANG_OPTIONS.includes(rnaAntisenseOverhang)) {
        processedData.rnaAntisenseOverhang = rnaAntisenseOverhang;
      }

      return processedData;
    }
}
